export const MARKETING_AUTOMATION_ROUTES = {
  marketingAutomation: '/marketing-automation',
  featuredApplications: '/marketing/apps',
};
